export enum ActiveServiceEnum {
    ACCETTAZIONE_DAL_CLIENTE = "ACCETTAZIONE_DAL_CLIENTE",
    CONSEGNA_AL_CORRIERE = "CONSEGNA_AL_CORRIERE",
    ACCETTAZIONE_DAL_CLIENTE_CON_STAMPA = "ACCETTAZIONE_DAL_CLIENTE_CON_STAMPA",
    ACCETTAZIONE_DAL_CORRIERE = "ACCETTAZIONE_DAL_CORRIERE",
    CONSEGNA_AL_CLIENTE = "CONSEGNA_AL_CLIENTE",
    VENDITA_PACCHI = "VENDITA_PACCHI",
    CREAZIONE_ORDINE_MATERIALI = "CREAZIONE_ORDINE_MATERIALI",
    STORICO_ORDINE_MATERIALI = "STORICO_ORDINE_MATERIALI",
    CREAZIONE_RESO_MATERIALI = "CREAZIONE_RESO_MATERIALI",
}
